module.exports = __webpack_public_path__ + "assets/367fd563b40f1e827b797dbc092fff23.png";